import React from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { api1 } from "../utils/axiosInstance";
import { API_ENDPOINTS } from "../services/apiEndpoints";

const schema = yup.object({
  name: yup.string().required("Name is required"),
  email: yup.string().email("Enter a valid email").required("Email is required"),
  subject: yup.string().required("Subject is required"),
  question: yup.string().required("Question is required"),
});

const InputField = ({ label, type = "text", register, error, ...props }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
    {type === "textarea" ? (
      <textarea {...register} {...props} className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-pink-500 resize-none" />
    ) : (
      <input type={type} {...register} {...props} className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-pink-500" />
    )}
    {error && <p className="text-red-500 text-xs mt-1">{error.message}</p>}
  </div>
);

const SubmitComponent = () => {
  const userId = useSelector((s) => s.auth.id);
  const { register, handleSubmit, reset, formState: { errors } } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (data) => {
    try {
      await api1.post(API_ENDPOINTS.SUBMIT_TICKET, { userId, ...data });
      reset();
    } catch (err) {
      console.error("Submission error:", err);
    }
  };

  return (
    <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
      <InputField label="Name" register={register("name")} error={errors.name} placeholder="Your full name" />
      <InputField label="Subject" register={register("subject")} error={errors.subject} placeholder="Brief description" />
      <InputField label="Your Email" type="email" register={register("email")} error={errors.email} placeholder="your.email@example.com" />
      <InputField label="Message" type="textarea" register={register("question")} error={errors.question} rows={4} placeholder="Describe your issue..." />
      <button type="submit" className="w-full bg-gradient-to-r from-pink-500 to-purple-600 text-white font-medium py-3 px-6 rounded-lg hover:from-pink-600 hover:to-purple-700 transition-all duration-200">
        Submit Request
      </button>
    </form>
  );
};

export default SubmitComponent;
